import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import ValibotFieldCheckbox from '~/components/valibot/ValibotFieldCheckbox';
import { FormHorizontal } from '~/components/form/layout';

export default function BreSocialSubmit(): ReactElement {
  return (
    <FormGroup>
      <FormHorizontal label="Self Edited Video">
        <ValibotFieldCheckbox id="self_edited" name="self_edited" />
      </FormHorizontal>
    </FormGroup>
  );
}
